import { Logo, PerchLogos } from '@perch-labs/shrike';
import { ReactNode } from 'react';
import { OneColumnGrid } from '~/components/layout';
import { Link } from '~/components/link';
import { IS_PERCH_ENERGY, WEBSITE_URL } from '~/utils/constants';

export const Wrapper = ({
  children,
  testId,
  showLogo = true,
}: {
  children: ReactNode;
  testId: string;
  showLogo?: boolean;
}) => {
  if (!showLogo) {
    return (
      <OneColumnGrid testId={testId} textAlign="center">
        {children}
      </OneColumnGrid>
    );
  }

  return (
    <OneColumnGrid testId={testId} textAlign="center">
      {IS_PERCH_ENERGY ? (
        <div style={{ paddingRight: '30px' }}>
          <PerchLogos type="perchCommunity" width={120} height={40} />
        </div>
      ) : (
        <Link color="primary" href={WEBSITE_URL} openInNewTab justifyContent="center">
          <Logo scale={8} type="circle" variant="default" />
        </Link>
      )}
      {children}
    </OneColumnGrid>
  );
};
